import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';

import NotificationsList from 'components/organisms/lists/NotificationsList';

import SectionTitle from '@/components/atoms/fonts/SectionTitle';
import ButtonBack from '@/components/BI/buttonBack';
import { isFeatureEnabled } from '@/constants/featureFlags';
import Meta from '@components/templates/Seo/Meta';
import useNotificationService from '@services/notification';

import { Header, Container, Main } from './styles';

const Notifications = () => {
    const dispatch = useDispatch();
    const segment = useSelector((state) => state.auth.currentSegment);
    const { getAllNotificationsUser, removeNotificationUser } = useNotificationService();
    const [notifications, setNotifications] = useState('');

    const getAllNotifications = () => {
        getAllNotificationsUser().then((resp) => {
            dispatch({ type: 'SET_NOTIFICATIONS', payload: resp.data });
            resp.data.length === 0 && dispatch({ type: 'SET_EMPTY', payload: true });
            setNotifications(resp.data);
        });
    };

    const removeNotification = (idNotification) => {
        removeNotificationUser(idNotification).then(() => {
            getAllNotifications();
        });
    };

    useEffect(() => {
        // Só busca notificações se a feature estiver habilitada
        if (isFeatureEnabled('NOTIFICACOES', segment)) {
            getAllNotifications();
        }
    }, [segment]);

    // Redireciona se a feature estiver desabilitada
    if (!isFeatureEnabled('NOTIFICACOES', segment)) {
        return <Navigate to="/" replace />;
    }

    return (
        <>
            <Meta title="Notificações" />

            <ButtonBack />
            <Container>
                <Header>
                    <SectionTitle tituloString={'Notificações'} />
                </Header>
                <Main>
                    <NotificationsList notifications={notifications} removeNotification={removeNotification} />
                </Main>
            </Container>
        </>
    );
};

export default Notifications;
